export const typeStore = [
  { name: 'Комиссионное', value: 'Комиссионное' },
  { name: 'Новое', value: 'Новое' },
  { name: 'Наши работы', value: 'Наше' },
];
